import $cookies from 'vue-cookies'
import router from '@/router'

export const redirectSignupManage = async () => {
  const signupManage = $cookies.get('signupManage')
  if (signupManage === 'manage') {
    await router.replace('/signup/manage')
    return true
  }
  return false
}
